import type { TDomainsFilters } from '@/server/services/Domains';
import type { ClientContext } from '@/client/context';
import { filterPresets } from '@/common/forms/domains/filters';
import SearchForm from '@/common/forms/domains/filters';

import type ClientRouter from '@client/services/router';
import type ServerRouter from '@server/services/router';

export const getCurrentFilters = (context): TDomainsFilters => {

    let filters: Partial<TDomainsFilters> = {}

    for (const fieldName in SearchForm.fields) {

        const [type] = SearchForm.fields[fieldName];
        let value = context.request.data[fieldName];

        if (value === undefined)
            continue;

        if (type === 'int')
            value = parseInt(value);

        filters[fieldName] = value;
    }

    filters.page = context.request.data.page ? parseInt(context.request.data.page) : 1;

    if (filters.keywords && filters.keywords in filterPresets) {
        // Avoid to confuse presets with searches
        filters.keywords = undefined;
        filters = { ...filters, ...filterPresets[filters.keywords] }
    }

    return filters;
}

export const encodeSearch = (kw: string) => encodeURIComponent(kw).replaceAll('%20', '+')

/*export const buildSearchUrl = (
    filters: Partial<TDomainsFilters>, 
    { Router, context }: ClientContext, 
    relative: boolean = true
) => {*/

// TODO: Move as client app service ?
export const buildSearchUrl = (
    filters: Partial<TDomainsFilters>, 
    Router: ClientRouter | ServerRouter, 
    relativeTo?: ClientContext
) => {

    if (relativeTo) {
        const currentFilters = getCurrentFilters(relativeTo);
        filters = { ...currentFilters, ...filters };
    }

    if (filters.keywords !== undefined) {
        const { keywords, ...otherFilters } = filters;
        return Router.url('/app/domains/' + encodeSearch(keywords), otherFilters, false);
    /*} else if (filters.sector !== undefined) {
        const { sector, ...otherFilters } = filters;
        return Router.url('/app/domains/sector/' + encodeSearch(sector), otherFilters, false);
    } else if (filters.tld !== undefined) {
        const { tld, ...otherFilters } = filters;
        return Router.url('/app/domains/tld/' + encodeSearch(filters.tld), otherFilters, false);*/
    } else
        return Router.url('/app/domains', filters, false);
}